import { FlexBox, LoadingButton } from '@airship-platform/jam-web/components';
import { BackButton } from '@airship-platform/airship-patterns';
import Divider from '@mui/material/Divider';
import { PropsWithChildren } from 'react';
import { DiscountAndFee } from '../../../data-access';
import {
  PercentageSectionEditable,
  PriceSectionEditable,
} from '../../add-products';

interface ManageModifierContentProps {
  modifier: {
    amount: number;
    taxable: boolean;
    amountType: DiscountAndFee['amountType'];
  };
  isLoading: boolean;
  isDisabled?: boolean;
  priceIsEditable?: boolean;
  submitButtonText?: string;
  onSubmit: () => void;
  onUpdateModifier: (changes: Partial<DiscountAndFee>) => void;
}

const ManageModifierContent: React.FC<
  PropsWithChildren<ManageModifierContentProps>
> = ({
  modifier,
  isLoading,
  isDisabled,
  submitButtonText,
  priceIsEditable,
  children,
  onSubmit,
  onUpdateModifier,
}) => (
  <FlexBox flexDirection={'column'} width={'100%'} gap={3}>
    <FlexBox flexDirection={'column'} gap={2} width={'100%'}>
      {modifier.amountType === 'PERCENTAGE' ? (
        <PercentageSectionEditable
          defaultValues={{ amount: modifier.amount * 100 }}
          isEditable={priceIsEditable !== false}
          startAdornment="%"
          onUpdateModifier={({ amount }) =>
            onUpdateModifier({ amount: amount / 100 })
          }
        />
      ) : (
        <PriceSectionEditable
          isEditable={priceIsEditable !== false}
          startAdornment="-"
          defaultPriceType={'STANDARD'}
          prices={[
            {
              priceType: 'STANDARD',
              value: modifier.amount,
              currency: 'USD',
              taxable: modifier.taxable,
            },
          ]}
          canEditPrice={true}
          onUpdateProduct={({ price }) => onUpdateModifier({ amount: price })}
        />
      )}
      <Divider />
    </FlexBox>

    {children}

    <FlexBox gap={2} justifyContent={'space-between'}>
      <BackButton
        color="softGold"
        size={'large'}
        sx={{ minWidth: '8rem' }}
        defaultPath="../"
      >
        Cancel
      </BackButton>
      <LoadingButton
        onClick={onSubmit}
        loading={isLoading}
        size={'large'}
        disabled={isDisabled}
        sx={{ minWidth: '8rem' }}
      >
        {submitButtonText || 'Add'}
      </LoadingButton>
    </FlexBox>
  </FlexBox>
);

export default ManageModifierContent;
